import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CodaltComponent } from '../../../codalt.component';
import { AuthService } from '../../../services/auth/auth.service';
import { RequestRestorePasswordState } from './request-restore-password-state.enum';

@Component({
    selector: 'app-request-restore-password',
    templateUrl: './request-restore-password.component.html',
    styleUrls: ['./request-restore-password.component.scss'],
    standalone: false,
})
export class RequestRestorePasswordComponent extends CodaltComponent implements OnInit {
    public RequestRestorePasswordState = RequestRestorePasswordState;
    environment = environment;

    form = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
    });
    public requestState: RequestRestorePasswordState = RequestRestorePasswordState.FillInEmail;
    public errorMessage: string | null = null;

    constructor(
        private authService: AuthService,
        private activatedRoute: ActivatedRoute
    ) {
        super();
    }

    ngOnInit() {
        const email = this.activatedRoute.snapshot.queryParamMap.get('email');
        if (email) {
            this.form.controls.email.setValue(email);
        }
    }

    requestPasswordEmail() {
        this.requestState = RequestRestorePasswordState.SendingEmail;
        this.errorMessage = null;
        this.subscriptions.add(
            this.authService.requestRestorePassword(this.form.value.email).subscribe({
                next: () => (this.requestState = RequestRestorePasswordState.SendedEmail),
                error: error => {
                    this.errorMessage = error?.message;
                    this.requestState = RequestRestorePasswordState.SendEmailFail;
                },
            })
        );
    }

    tryAgain() {
        this.errorMessage = null;
        this.requestState = RequestRestorePasswordState.FillInEmail;
    }
}
